export const ManualAddressItemMessages = {
  manualLink: {
    id: 'Pages.ConsumerAddress.Auto.dropdownManualLink',
    description: 'Enter address manually'
  }
}
